module.exports = __webpack_public_path__ + "static/media/logo_softwone_white.bb4a0f6d.svg";